import React from 'react';
import { Route, Redirect } from 'react-router-dom';

type AppProps = {
  isLoggedIn: boolean;
  path: string;
  exact: boolean;
  component: any;
  key: string;
  isPrivate: boolean;
  name: string;
}

const PublicRoutes = ({ component: Component, isLoggedIn, ...rest }: AppProps) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return !isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect from={props.match.path} to='/' exact />
        )
      }
      }
    />
  )
}

export default PublicRoutes;